import { useEffect, useState } from 'react';

import type { Editor } from '@tiptap/core';

// Subscribes to editor events directly instead of useEditorState, which
// doesn't reliably re-render node view components. We listen for `update`
// because `editor.setEditable()` emits an `update` event.
export function useIsEditorEditable(editor: Editor): boolean {
  const [isEditable, setIsEditable] = useState(editor.isEditable);

  useEffect(() => {
    const handler = () => {
      setIsEditable(editor.isEditable);
    };
    editor.on('update', handler);
    return () => {
      editor.off('update', handler);
    };
  }, [editor]);

  return isEditable;
}
